import { QueryDocumentSnapshot, SnapshotOptions, WithFieldValue } from "firebase/firestore";

export const firebaseDataConverter = {
    toFirestore<T>(value: WithFieldValue<T>) {
        return value;
    },
    fromFirestore<T>(
        snapshot: QueryDocumentSnapshot,
        options: SnapshotOptions
    ) {
        const data = snapshot.data(options);
        return {
            ...data,
            id: snapshot.id
        } as T;
    }
};